module.exports = __webpack_public_path__ + "img/dark-mud-decal-11.103367b6.png";